import { createAuthedHttpClient } from '@driftt/web-auth'
import config from 'config'

export const CustomerAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CUSTOMER_API
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: []
})

export const ConversationAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.CONVERSATION_API
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: []
})

export const AuthAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.AUTH_API
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: []
})

export const FileAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.FILE_API,
    raw: true
  }
})

export const MeetingsAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.MEETINGS_API,
    raw: true
  }
})

export const KongCustomerAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.KONG_CUSTOMER_API
  }
})

export const BillingAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.BILLING_API
  }
})

export const DriftMetricsAPI = createAuthedHttpClient({
  baseConfig: {
    baseURL: config.METRICS_API
  }
})